module.exports = __webpack_public_path__ + "static/media/wszystko-o-rodo-cover-pl@2x.c5f20719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/wszystko-o-rodo-cover-pl@2x.jpg
// module id = 561
// module chunks = 0